import BrowserStorageCache from "./BrowserStorageCache";

class LocalStorageCache extends BrowserStorageCache {
    constructor() {
        super(localStorage);
    }
}

export default LocalStorageCache;